
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loans/car-and-personal-loans/apply-now",
      function () {
        return require("private-next-pages/loans/car-and-personal-loans/apply-now.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loans/car-and-personal-loans/apply-now"])
      });
    }
  